import { ready } from '~/core'
import addEvents from '~/utils/addEvents'
ready('pagination', '.pagination', (pagination) => {
    if (pagination) {
        const buttons = pagination.querySelectorAll('.pagination-btn');
        buttons.forEach((printButton) => {
            addEvents(printButton, 'click.prevent', (e) => {
                let pageUrl = printButton.getAttribute('data-url');
                if (pageUrl) {
                    window.location = pageUrl;
                }
            })
        })
    }
})

ready('paginationnonsc', '.pagination-non-sc', (pagination) => {
    if (pagination) {
        const buttons = pagination.querySelectorAll('.pagination-btn');
        buttons.forEach((printButton) => {
            addEvents(printButton, 'click.prevent', (e) => {
                let pageUrl = printButton.getAttribute('data-url');
                if (pageUrl) {
                    window.location = pageUrl;
                }
            })
        })
    }
})